import React, { useCallback, useEffect, useMemo, useState } from "react";
import * as RB from "react-bootstrap";
import DataTable from "react-data-table-component";
import * as utils from "../../Utils/comman";
import CustomPagination from "../../Utils/CustomPagination";
import { useSelector } from "react-redux";
import { AddCircle, DocumentDownload, Eye } from "iconsax-react";
import moment from "moment";
import { useLocation } from "react-router-dom";

function EmpBrandingList(props) {
  const [brandList, setbrandList] = useState([]);
  const [page, setPage] = useState(1);
  const countPerPage = 10;
  const [filterText, setFilterText] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const primaryMenuRes = useSelector(
    (state) => state?.primaryMenu?.primaryMenu?.permissions
  );
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  const id = queryParams.get("id");

  const columns = [
    {
      name: "Counter",
      selector: (row) => row.dealership_name,
      width: "200px",
    },
    {
      name: "Subject",
      selector: (row) => row.subject,
    },
    // {
    //   name: "Zonal Head",
    //   selector: (row) => row.zonal_head,
    // },
    {
      name: "Total Amount",
      selector: (row) => row.total_amt,
    },
    {
      name: "Action",
      center: true,
      cell: (row) => (
        <>
          <RB.Button className="btn btn-flat me-1" onClick={handleView(row)}>
            <Eye />
          </RB.Button>
        </>
      ),
    },
  ];

  const handleView = useCallback((row) => async () => {
    const propdata = {
      mode: "view",
      rowData: row,
    };
    props.onChange(propdata);
  });

  useEffect(() => {
    getEmpbrandList();
  }, [page,id]);

  const getEmpbrandList = () => {
    utils
      .callAPI(
        "get",
        `/meeting/branding/list-keypersion?id=${
          id ? id : ""
        }&page=${page}&per_page=${countPerPage}`
      )
      .then((res) => {
        if (typeof res !== "undefined") {
          setbrandList(res);
          if (id) {
            const found = res.result.find(
              (item) => Number(item.id) === Number(id)
            );
            if (found) {
              props.onChange({
                mode: "view",
                rowData: found,
              });
            }
          }
        } else {
          setbrandList([]);
        }
      })
      .catch((err) => {
        setbrandList([]);
      });
  };

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  const handleDownload = () => {
    utils
      .callAPI("get", `/meeting/branding/list-keypersion??page=0&per_page=0`)
      .then((res) => {
        const rows = Array.isArray(res?.result) ? res.result : [];
        if (!rows.length) {
          return;
        }

        // Header (exact order as requested)
        const csvHeader = [
          "Requested Date",
          // "Key Person Name",
          "Subject",
          "Description",
          "Counter Name",
          "State",
          "District",
          "City",
          "Reporting",
          "Total Amt",
        ].join(",");

        const esc = (v) => `${v ?? ""}`.replace(/"/g, '""'); // CSV-escape quotes

        const csvRows = rows.map((r) => {
          const requestedDate = r.createdAt
            ? moment(r.createdAt).format("DD-MM-YYYY")
            : "";

          const state = r.state ?? r.state_name ?? "";
          const district = r.district ?? r.district_name ?? "";
          const city = r.city ?? r.city_name ?? "";
          const rm = `${r.rm_firstname} ${r.rm_lastname}`.trim();

          return [
            `"${esc(requestedDate)}"`,
            // `"${esc(r.emp_name)}"`,
            `"${esc(r.subject)}"`,
            `"${esc(r.subject_detail)}"`,
            `"${esc(r.dealership_name)}"`,
            `"${esc(state)}"`,
            `"${esc(district)}"`,
            `"${esc(city)}"`,
            `"${esc(rm)}"`,
            `"${esc(r.total_amt)}"`,
          ].join(",");
        });

        const csvContent = [csvHeader, ...csvRows].join("\n");

        const blob = new Blob([csvContent], {
          type: "text/csv;charset=utf-8;",
        });
        const link = document.createElement("a");
        const ts = new Date()
          .toISOString()
          .slice(0, 19)
          .replace("T", "_")
          .replace(/:/g, "-");

        link.href = URL.createObjectURL(blob);
        link.download = `MyBranding.csv`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
      .catch((err) => {});
  };
  return (
    <div className="section-body">
      <RB.Card className="card shadow ">
        <RB.Card.Header>
          <div className="floating-btns-holder-artisan">
            <a
              href
              className={`${
                brandList?.result?.length == 0 ? "disabled" : ""
              } btn btn-primary btn-circle ms-2`}
              variant="primary"
              onClick={() => handleDownload()}
            >
              <DocumentDownload />
            </a>
          </div>
        </RB.Card.Header>
        <RB.Card.Body>
          <DataTable
            columns={columns}
            data={brandList.result}
            highlightOnHover
            responsive
            pagination
            paginationServer
            paginationTotalRows={brandList.total}
            paginationPerPage={countPerPage}
            paginationComponentOptions={{
              noRowsPerPage: true,
            }}
            paginationComponent={() => (
              <CustomPagination
                currentPage={page}
                totalRows={brandList.total}
                rowsPerPage={countPerPage}
                onPageChange={handlePageChange}
              />
            )}
            striped
            onChangePage={(page) => setPage(page)}
            persistTableHead
            customStyles={{
              head: {
                style: {
                  fontSize: "0.875rem", // Adjust the font size as needed
                  fontWeight: "bold", // Adjust the font weight as needed
                },
              },
            }}
          />
        </RB.Card.Body>
      </RB.Card>
    </div>
  );
}

export default EmpBrandingList;
